export const STORAGE_BUCKET_KEY = 'moments_bucket'
